import {AxiosInstance} from 'axios';
// enums
import {API_URL, STORAGE_KEY} from '@/utils/enums';
import {AppStorage} from '@/utils/services/storage.service';

export type Tokens = {
	refreshToken: string;
	jwtBearerToken: string;
};

/**
 * Універсальна функція для оновлення JWT токенів
 * @param storage Інстанс стореджу (orgStorage, userStorage або adminStorage)
 * @param authAPIInstance Axios інстанс без інтерцепторів для виконання запиту
 */
export const refreshTokens = async (
	storage: AppStorage,
	authAPIInstance: AxiosInstance
): Promise<string | undefined> => {
	const refreshToken = storage.get<string>(STORAGE_KEY.REFRESH_TOKEN);
	const jwtBearerToken = storage.get<string>(STORAGE_KEY.JWT_BEARER_TOKEN);

	if (!refreshToken || !jwtBearerToken) {
		return undefined;
	}

	try {
		const {data} = await authAPIInstance.post<Tokens>(API_URL.REFRESH_TOKEN, {
			refreshToken,
			jwtBearerToken,
		});

		if (data && data.jwtBearerToken) {
			storage.set(STORAGE_KEY.JWT_BEARER_TOKEN, data.jwtBearerToken);
			storage.set(STORAGE_KEY.REFRESH_TOKEN, data.refreshToken);
			return data.jwtBearerToken;
		}
	} catch (error) {
		storage.remove(STORAGE_KEY.JWT_BEARER_TOKEN);
		storage.remove(STORAGE_KEY.REFRESH_TOKEN);

		return undefined;
	}
};
